import { render, staticRenderFns } from "./DashboardFree.vue?vue&type=template&id=e4827fcc&scoped=true&"
import script from "./DashboardFree.vue?vue&type=script&lang=js&"
export * from "./DashboardFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4827fcc",
  null
  
)

export default component.exports